import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

// Renders overlays at document.body so ancestor stacking contexts
// (e.g. .ae-shell-main) can't trap them behind the sidebar.
export default function ModalPortal({ children }: any) {
  const [container] = useState(() => document.createElement('div'));

  useEffect(() => {
    document.body.appendChild(container);
    return () => {
      document.body.removeChild(container);
    };
  }, [container]);

  return createPortal(children, container);
}
